import { IReportingPeriodApplicant } from "./ReportingPeriodApplicant";
import { DateService } from "../../service/DateService";

export interface TReportingPeriodApplicantPresentationModel {
  reportingPeriodApplicantId: number;
  reportingPeriodId: number;
  periodFrom?: string;
  periodTo?: string;
  reportingTypeCode: string;
  reportingTypeName: string;
  applicantId: number;
  firstName: string;
  lastName: string;
  partyId: number;
  partyPersonalIdentificationNumber: string;
  isEvaluationCandidate: string;
  evaluationReason: string;
  evaluationStatus: string;
  evaluationDate?: string;
  inputAvailableUntil?: string;
  expectedReportsNumber: number;
  submitedReportsNumber: number;
}

const ReportingPeriodApplicantPresentationModel = (
  data: IReportingPeriodApplicant
): TReportingPeriodApplicantPresentationModel => {
  const periodTo = data.periodTo
    ? DateService().formatDate(data.periodTo)
    : undefined;
  const periodFrom = data.periodTo
    ? DateService().formatDate(data.periodFrom)
    : undefined;
  const evaluationDate = data.evaluationDate
    ? DateService().formatDate(data.evaluationDate)
    : undefined;
  const inputAvailableUntil = data.inputAvailableUntil
    ? DateService().formatDate(data.inputAvailableUntil)
    : undefined;
  return {
    ...data,
    periodFrom: periodFrom,
    periodTo: periodTo,
    evaluationDate: evaluationDate,
    inputAvailableUntil: inputAvailableUntil
  };
};

export default ReportingPeriodApplicantPresentationModel;
